/**
 * Zet tekst op het klembord en gooit een fout als dat niet lukt.
 *
 * De HubSpot-iframe blokkeert de Clipboard API; dan kopieert een onzichtbaar tekstveld met
 * `execCommand('copy')`. Dat veld komt in de open dialoog: de focus-trap van Radix trekt de
 * focus anders direct terug, waarna er niets geselecteerd is en er niets wordt gekopieerd.
 */
export async function copyText(value: string) {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      return;
    } catch {
      // Geblokkeerd door de iframe; probeer het via een geselecteerd tekstveld.
    }
  }
  const focused = document.activeElement;
  const host =
    (focused instanceof HTMLElement && focused.closest('[role="dialog"], [role="alertdialog"]')) ||
    document.body;
  const field = document.createElement('textarea');
  field.value = value;
  field.setAttribute('readonly', '');
  field.setAttribute('aria-hidden', 'true');
  field.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none;';
  host.appendChild(field);
  try {
    field.focus({ preventScroll: true });
    field.setSelectionRange(0, value.length);
    if (!document.execCommand('copy')) throw new Error('Clipboard unavailable');
  } finally {
    field.remove();
    if (focused instanceof HTMLElement) focused.focus({ preventScroll: true });
  }
}
